import ACL_RELATIONSHIPS from "acl-relationships";
import useAuthorized from "hooks/useAuthorized";
import useCanReadRegistrantLeads from "routes/leads/swoogo_registrants/useCanReadRegistrantLeads";

// The filter lists the Meta Leads Events, so it also needs the permission to
// read them.
export default function useCanFilterRegistrantLeads() {
  const canReadLeads = useCanReadRegistrantLeads();
  const canReadStatuses = useAuthorized([
    ACL_RELATIONSHIPS.metaLeadsEvent.read,
  ]);
  return canReadLeads && canReadStatuses;
}
